import {
	JSON_FORM,
	UPDATE_CURRENT_QUESTION_TREE_ID,
} from '#app/constants/forms.ts'
import { type State, type Action } from '#types/form/wizard.ts'

export function handleUpdateCurrentQuestionTreeId<T>(
	state: State<T>,
	action: Action<T>,
): State<T> {
	if (
		state.type !== JSON_FORM ||
		action.type !== UPDATE_CURRENT_QUESTION_TREE_ID
	) {
		return state
	}

	const parentTree = state.answeredQuestionsStack.find(
		item => item.id === action.currentQuestionTreeId,
	)
	const lastAnsweredQuestionInsideParentTree =
		parentTree?.answers[parentTree?.answers.length - 1]

	return {
		...state,
		currentQuestionTreeId: action.currentQuestionTreeId,
		currentQuestionId: lastAnsweredQuestionInsideParentTree ?? '',
	}
}
